import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DataService } from "../../../data.service";
import { ClientsRegistrationDataModel } from '../../../model';
import { AuthService } from '../../../auth/auth.service';

@Component({
    selector: 'app-clients-dasboard',
    templateUrl: './clients-dashboard.component.html',
    styleUrls: ['./clients-dashboard.component.css'],
    standalone: false
})
export class ClientsDashboardComponent implements OnInit {
    clientList!: ClientsRegistrationDataModel[];

    clientDialogVisible: boolean = false;
    currentClient?: ClientsRegistrationDataModel;
    resetPasswdDlgVisible: boolean = false;

    constructor(private dataService: DataService, private authService: AuthService) {
    }

    ngOnInit() {
        const subscr = this.dataService.clientsData().subscribe({
            next: (result) => {
                this.clientList = result;
            },
            error: (err: HttpErrorResponse) => {
                subscr.unsubscribe();
            },
            complete: () => {
                subscr.unsubscribe();
            }
        });
    }

    removeClient(clientId: number) {
        if (confirm("Внимание! Подтвердите удаление пользователя!")) {
            const subscr = this.authService.deleteClient(clientId)
                .subscribe({
                    next: (result) => {
                        this.clientList = this.clientList.filter((client) => client.id != clientId);
                    },
                    error: (err) => {
                        alert(err.message);
                    },
                    complete: () => {
                        subscr.unsubscribe();
                    }
                });
        }
    }

    exportClientsList() {
        function toCSV(d: ClientsRegistrationDataModel) {
            return `"${d.login}";"${d.client_code}";"${d.first_name}";${d.last_name};"${d.client_city}";"${d.phone}";"${d.email}"\n`
        }

        function downloadAsFile(data: string) {
            const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const blob = new Blob([BOM, data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `clients.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        }

        let blobData = '"Username";"Client code";"First Name";"Last Name";"City";"Phone";"Email"\n';
        this.clientList.forEach((element: ClientsRegistrationDataModel) => {
            blobData += toCSV(element);
        });

        downloadAsFile(blobData);

    }

    editClient(clientData: ClientsRegistrationDataModel) {
        this.clientDialogVisible = true;
        this.currentClient = clientData;
    }

    resetPasswd(clientData: ClientsRegistrationDataModel) {
        this.resetPasswdDlgVisible = true;
        this.currentClient = clientData;
    }

    dataChanged(data: any) {
        for (let i: number = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].id === data.id) {
                this.clientList[i] = { ...this.clientList[i], ...data };
                break;
            }
        }
    }

    hideClientDialog() {
        this.currentClient = undefined;
    }

}
